import React from 'react';

const SummaryField = ({ title, value }) => {
  return (
    <div className="row">
      <label className="title">{title}</label>
      <div className="right">
        {value}
      </div>
    </div>
  );
}

export default SummaryField;



// WEBPACK FOOTER //
// ./src/components/projects/ProjectSummary/SummaryField.js